<template>
  <div>
    <Header v-if="path != '/login' && path != '/register' && path != '/pidregister'" />
    <router-view />
    <Left v-if="path != '/login' && path != '/register' && path != '/pidregister'" />
    <!-- @touchmove.prevent  遮罩层禁止滑动 -->
    <div data-v-377afdca="" class="loading-mask-container" v-if="loading" @touchmove.prevent style="">
      <div data-v-377afdca="" class="loading-icon-wrapper"><img data-v-377afdca="" src="/static/image/rotate.9636734b.png" alt="" class="loading-rotate-img" /></div>
    </div>
  </div>
</template>

<script>
import Header from './libs/Header';
import Left from './libs/Left';
export default {
  name: 'Main',
  data() {
    return { loading: false, path: '', daoTime: null };
  },
  components: {
    Header,
    Left,
  },
  created() {
    let that = this;
    if (sessionStorage.getItem('token')) {
      that.openDaoTime();
    }
  },
  updated() {},
  mounted() {
    var mySwiper = new Swiper('.swiper', {
      slidesPerView: '1',
    });
    $(window).scroll(function () {
      if ($(document).scrollTop() <= 50) {
        $('.header-container').removeClass('headerBg');
        $('.games-tab.clearfix').removeClass('stuck');

        $('#headerBefore').css('height', '');
      } else {
        $('.header-container').addClass('headerBg');
        $('.games-tab.clearfix').addClass('stuck');
        $('#headerBefore').css('height', '50px');
      }
    });
    $('.header-button.left').click(function () {
      $('.sidebar-container .sidebar').addClass('active').removeClass('inactive');
      $('.sidebar-container .cover').addClass('active').removeClass('inactive');
      $('body').css('overflow-y', 'hidden');
    });

    $('.sidebar-container .cover').click(function () {
      $('.sidebar-container .sidebar').addClass('inactive').removeClass('active');
      $('.sidebar-container .cover').addClass('inactive').removeClass('active');
      $('body').css('overflow-y', 'visible');
    });
  },
  methods: {
    openDaoTime() {
      let that = this;
      that.daoTime = setInterval(() => {
        that.getBalance();
      }, 3300);
    },
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.closeDaoTime();
            that.$router.push({ path: '/' });
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    // 打开游戏
    openGamePage(name, type, code) {
      let that = this;
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');
        return;
      }
      that.showTost(1, '跳转中...');

      that.showLoading();
      if (name == 'avia') {
        that.hideLoading();
        that.goNav(`/gamePage?name=${name}&type=${type}&code=${code}`);
        return;
      }
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          if (res.code != 200) {
            that.hideLoading();
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            window.location.href = res.data.url;
            setTimeout(() => {
              that.hideLoading();
            }, 1000);
          }
        })
        .catch(res => {
          let that = this;
          that.showTost(0, '网络连接超时，请重试!');
          that.hideLoading();
        });
    },
    // openGamePage(name, type, code) {
    //   let that = this;
    //   let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
    //   if (!token) {
    //     that.showTost(0, '请登录！');
    //     $('.mask').fadeOut(300);
    //     $('.mask.login').fadeIn(300);
    //     return;
    //   }
    //   that.goNav(`/gamePage?name=${name}&type=${type}&code=${code}`);
    // },

    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          that.goNav('/');
        }
        that.hideLoading();
      });
    },
    getUserInfos() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
          that.$router.go(-1);
        }
        that.hideLoading();
      });
    },
    getUserInfoss() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
        that.hideLoading();
      });
    },
    openKefu() {
      let that = this;
      that.goNav(`/kefu`);
    },
    showTost(type, str) {
      let that = this;
      // icon-success
      let icon = type ? 'icon-success' : 'icon-error';
      $('body').append(`
            <div  class="toast-container ants-message" ><i  class="toast-icon ${icon}"></i><p  class="toast-text">${str}</p></div>`);
      setTimeout('$(".ants-message").detach()', 2000);
    },
    goNav(url) {
      let that = this;
      if (url == '/hongbao') {
        if (!that.$store.state.token) {
          this.$router.push({ path: '/login' });
          return;
        }
        if (that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, '红包已关闭');
          return;
        }
      }
      if (url == this.$route.fullPath) {
        that.showTost(0, '已在当前页面！');
        return;
      }
      $('.sidebar-container .sidebar').addClass('inactive').removeClass('active');
      $('.sidebar-container .cover').addClass('inactive').removeClass('active');
      $('body').css('overflow-y', 'visible');
      this.$router.push({ path: url });
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
  },
  updated() {
    $('.header-button.left').click(function () {
      $('.sidebar-container .sidebar').addClass('active').removeClass('inactive');
      $('.sidebar-container .cover').addClass('active').removeClass('inactive');
      $('body').css('overflow-y', 'hidden');
    });

    $('.sidebar-container .cover').click(function () {
      $('.sidebar-container .sidebar').addClass('inactive').removeClass('active');
      $('.sidebar-container .cover').addClass('inactive').removeClass('active');
      $('body').css('overflow-y', 'visible');
    });
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.path = this.$route.path;
      },
    },
  },
  beforeDestroy() {
    let that = this;
    that.closeDaoTime();
  },
};
</script>

<style lang="scss" scoped>
.loading-icon-wrapper {
  background: url('/static/image/loading.png') no-repeat 50% !important;
  background-size: 20px 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue